var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.115,
    height: 30.696,
    viewBox: "0 0 25.115 30.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159219",
    "data-name": "Path 159219",
    d: "M13.651,23.162a1.452,1.452,0,0,0,2.232,0l8.372-8.79c.7-.7,0-1.814-1.116-1.814H17.558s.279-6.418,0-9.767A2.894,2.894,0,0,0,14.767,0a2.894,2.894,0,0,0-2.791,2.791c-.279,3.209,0,9.767,0,9.767H6.4a1.22,1.22,0,0,0-1.116,1.953Z",
    transform: "translate(-2.21)",
    fill: "#00c6b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159220",
    "data-name": "Path 159220",
    d: "M25.325,19H5.791A2.8,2.8,0,0,0,3,21.791H3a1.318,1.318,0,0,0,1.4,1.4H26.72a1.318,1.318,0,0,0,1.4-1.4h0A2.8,2.8,0,0,0,25.325,19Z",
    transform: "translate(-3 7.51)",
    fill: "#00c6b1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAll);
export default __webpack_public_path__ + "static/media/downloadAll.faf9ed1e5f3a6d44322433a85d1b65d5.svg";
export { ForwardRef as ReactComponent };